import React from 'react';

const Radio = props => {
    const {
        name,
        onChange,
        checked
    } = props

    return (
        <div className="radio-container">
            <input
                type="radio"
                name={name}
                value={1}
                onChange={onChange}
                checked={checked} 
            />
            <em />
        </div>
    )
};

export default Radio;
